import React, { Component } from 'react'
import Slider from "react-slick";
import {Link, useRouteMatch} from 'react-router-dom';
import FpgDisableIcon from './../../../icons/fpgdisableicon';
import FpgpublishIcon from './../../../icons/fpgpublishicon';
import FpgDeleteIcon from './../../../icons/fpgdeleteicon';
import FpgeeditIcon from '../../../icons/fpgediticon';
import service from '../../../services';
import { bindActionCreators } from 'redux';
import { ActCreators } from '../../../redux/bindActionCretor';
import { connect } from 'react-redux';
import PopUpCustomAll from '../../../component/fpg/create/popUpCustomAll';
import Loader from '../../../component/loader';
import ErrorPopUp from '../../../component/errorPopUp';
import { PAF_TYPES, isNewFrontierCategory } from '../../../cosntants';


// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
// import { ActCreators } from './../../redux/bindActionCretor'

const mapStateToProps = state => ({
    PostAcceptanceEditListId:state.PostAcceptanceEditListId
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
let sub;

const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/embed/') || url.includes('player.vimeo.com/video/')) return url;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    return url;
};

class ProjectinfoView extends Component {

    constructor(props) {
        super(props)
        this.apiserve = new service();
        this.state = {
            projectUserId: this.props.PostAcceptanceEditListId,
            deleteFilm:false,
            publishFilm:false,
            disableFilm:false,
        }
    
    }
    moveObjectAtIndex = (array, sourceIndex, destIndex) => {
        var placeholder = {};
        // remove the object from its initial position and
        // plant the placeholder object in its place to
        // keep the array length constant
        var objectToMove = array.splice(sourceIndex, 1, placeholder)[0];
        // place the object in the desired position
        array.splice(destIndex, 0, objectToMove);
        // take out the temporary object
        array.splice(array.indexOf(placeholder), 1);
        return array
    }
    componentDidMount = () => {

        if(this.state.projectUserId){
            this.apiserve.sendevent("paf|project|getProjectInfo", {
                id:this.state.projectUserId
            });

            this.apiserve.sendevent("paf|project|getDetail", {})            
        }
        

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case 'paf|project|getDetail':
                    if(!response.error){
                        this.setState({
                            filmCategoryData:response.data.filmCategoryData,
                            pafType:response.data.pafType,
                            filmcreditLabels:response.data.filmcreditLabels,
                        })
                    }
                    break;
                 
     
              
                case "paf|project|getProjectInfo":
                    
                    if(!response.error){
                        let len = response?.data?.logline ? response?.data?.logline.split(' ') : response?.data?.synopsis.split(' ')
                        len = len?.filter(_ => _ !== '');

                        let castIndex =response.data.credits.findIndex(element => element.identifier === 'principalcast')
                        let creditLastIndex = response.data.credits.length 
                        let len1 = response?.data?.logline ? response?.data?.logline.split(' ') : response?.data?.synopsis.split(' ')
                        len1 = len1?.filter(_ => _ !== '');

                        this.setState({
                            SynopsisLength: len.length,
                            userInfo: {
                                pafType: response.data.pafType,
                                images:response.data.images.length === 0 ? [ { _id:Math.random().toString(), link: "", inSite: "" }, { _id:Math.random().toString(), link: "", inSite: "" }, { _id:Math.random().toString(), link: "", inSite: "" } ] : response.data.images, 
                                projectId:response.data._id,
                                fileMakerId:response.data.fileMakerId,
                                mediaId:response.data.mediaId,
                                englishPhoneticProdununciation:response.data.englishPhoneticProdununciation,
                                // credits:this.moveObjectAtIndex(response.data.credits, castIndex ,creditLastIndex), 
                                credits:response.data.credits, 
                                filmCategoryData:response.data.filmCategoryData,
                                category: response.data.category,
                                article: response.data.article,
                                title: response.data.title,
                                logline: response?.data?.logline || response?.data?.synopsis,
                                countryOfOrigin:response.data.countryOfOrigin,
                                filmProjectType:response.data.filmProjectType,
                                status:response.data.status,
                                projectInfo: {
                                    soundFormat:response.data.projectInfo.soundFormat,
                                    premiereStatus: response.data.projectInfo.premiereStatus,
                                    yearFinished: response.data.projectInfo.yearFinished,
                                    inPersonFormat: response.data.projectInfo.inPersonFormat,
                                    onlineFormat: response.data.projectInfo.onlineFormat,
                                    aspectRatio: response.data.projectInfo.aspectRatio,
                                    color: response.data.projectInfo.color,
                                    language: response.data.projectInfo.language,
                                    subtitles: response.data.projectInfo.subtitles,
                                    finalRunTime: response.data.projectInfo.finalRunTime,
                                    runTime: response.data.projectInfo.runTime,
                                    includeStroboscopicImg: response.data.projectInfo.includeStroboscopicImg,
                                    aiAspect: response.data.projectInfo.aiAspect,
                                    aiAspectOther: response.data.projectInfo.aiAspectOther,
                                    timecodeOccursInProject: response.data.projectInfo.timecodeOccursInProject,
                                    captionAudioInDCP:response.data.projectInfo.captionAudioInDCP,
                                    allOfYourScreening: response.data.projectInfo.allOfYourScreening,
                                    repeatScreening: response.data.projectInfo.repeatScreening,
                                    premiereScreening: response.data.projectInfo.premiereScreening,
                                    requiredDCP: response.data.projectInfo.requiredDCP,
                                    requiredDCPAndProResFile: response.data.projectInfo.requiredDCPAndProResFile,
                                    requiredDCPAndProResFileOther: response.data.projectInfo.requiredDCPAndProResFileOther,
                                    requiredDCPOther: response.data.projectInfo.requiredDCPOther,
                                    premiereScreeningOther: response.data.projectInfo.premiereScreeningOther,
                                    repeatScreeningOther: response.data.projectInfo.repeatScreeningOther,
                                    allOfYourScreeningOther: response.data.projectInfo.allOfYourScreeningOther,
                                },
                                digitalMedia : {
                                    officialWebsite : response.data.digitalMedia.officialWebsite,
                                    youtubeOrVimeoTrailer: response.data.digitalMedia.youtubeOrVimeoTrailer,
                                    instagram: response.data.digitalMedia.instagram,
                                    facebook: response.data.digitalMedia.facebook,
                                    twitter: response.data.digitalMedia.twitter,
                                    hastag: response.data.digitalMedia.hastag,
                                    tiktok: response.data.digitalMedia.tiktok,
                                    bluesky: response.data.digitalMedia.bluesky,
                                },
                                publicContact: {
                                    firstName: response.data.publicContact.firstName,
                                    middleName: response.data.publicContact.middleName,
                                    lastName: response.data.publicContact.lastName,
                                    company: response.data.publicContact.company,
                                    publicEmail: response.data.publicContact.publicEmail,
                                    website: response.data.publicContact.website,
                                    phoneNumber: response.data.publicContact.phoneNumber,
                                    type: response.data.publicContact.type,
                                },
                                postFestivalContact: {
                                    firstName: response.data.postFestivalContact.firstName,
                                    middleName: response.data.postFestivalContact.middleName,
                                    lastName: response.data.postFestivalContact.lastName,
                                    company: response.data.postFestivalContact.company,
                                    publicEmail: response.data.postFestivalContact.publicEmail,
                                    website: response.data.postFestivalContact.website,
                                    phoneNumber: response.data.postFestivalContact.phoneNumber,
                                    type: response.data.postFestivalContact.type,
                                },
                                secondPostFestivalContact: {
                                    firstName: response?.data?.secondPostFestivalContact?.firstName ?? "",
                                    middleName: response?.data?.secondPostFestivalContact?.middleName ?? "",
                                    lastName: response?.data?.secondPostFestivalContact?.lastName ?? "",
                                    company: response?.data?.secondPostFestivalContact?.company ?? "",
                                    publicEmail: response?.data?.secondPostFestivalContact?.publicEmail ?? "",
                                    website: response?.data?.secondPostFestivalContact?.website ?? "",
                                    phoneNumber: response?.data?.secondPostFestivalContact?.phoneNumber ?? "",
                                    type: response?.data?.secondPostFestivalContact?.type ?? "",
                                },
                            } 
                            
                        })
                }
                    
                break;
               
                case "paf|project|remove":
                    if(!response.error) {
                        this.props.history.push('/paf-projectlist')}
                    else this.apiserve.error(response.data.error)
                break;
                case "paf|project|updateStatus":
                    if(!response.error){
                        this.props.history.push('/paf-projectlist')
                    }
                    else{
                        this.setState({
                        errorPopup:true,
                        errorMsg: response.data.error ? response.data.error : response.data        
                    })
                    }
                break;
                default:
                break;
            }
        });
    }

    // componentDidMount = () => {       
    //     sub.unsubscribe();
    // }
    editProjectInfo = () => {
        // this.props.PostAcceptanceEditList(id)
        this.props.history.push(`/paf-project/${this.state.projectUserId}/Edit`)
    }
    deleteFilm = () => {
        this.setState({
          deleteFilm:true
        })  
      }
    
      deleteFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|remove", {
            projectId:this.state.userInfo.projectId
        });
      }
    
      publishFilm = () => {
        this.setState({
          publishFilm:true
        })  
      }
    
      publishFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|updateStatus", {
            projectId:this.state.userInfo.projectId,
            status: 1
        });
      }
    
      disableFilm = () => {
        this.setState({
          disableFilm:true
        })  
      }
    
      disableFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|updateStatus", {
            projectId:this.state.userInfo.projectId,
            status: 2
        });
      }
      errorMsgPopup = () => {
        this.setState({
            errorPopup:false
        })  
      }
    closeAdminUser = () => {
        this.setState({
          deleteFilm:false,
          publishFilm:false,
          disableFilm:false
        })
    }
    getCategoryName = (id) => {
        return this.state.filmCategoryData && this.state.filmCategoryData.filter(_ => _._id === id).length > 0 && this.state.filmCategoryData.filter(_ => _._id === id)[0]?.name
    }

    render() {
        var settings = {
            customPaging: function (i) {
              return <a>{i + 1}</a>;
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        
        return (
            <>
            <div className="d_flex project_section">
                <div className="tab_col  create_left_col">
                    <div className="d_flex left_col d_flex_align_center">
                        <div className="id_media">
                            <span className="id_text">
                                <label>Media ID: {this.state.userInfo?.mediaId}</label> 
                            </span>
                        </div>
                    </div>
                    <div className="d_flex id_media d_flex_align_center">
                        <span className="id_text">
                            <label>Filemaker ID: {this.state.userInfo?.fileMakerId}</label> 
                        </span>
                    </div>
                    <div className="left_col">
                        <Slider {...settings}>
                        {/* {this.state.images &&
                        this.state.images.map((item) => ( */}
                        {/* <div>
                             <div className="media_image"><img src="/images/image-placeholder.png" alt="image"/></div>
                        </div>
                        <div>
                             <div className="media_image"><img src="/images/image-placeholder.png" alt="image"/></div>
                        </div>
                        <div>
                             <div className="media_image"><img src="/images/image-placeholder.png" alt="image"/></div>
                        </div> */}
                        {/* ))} */}
                        {this.state.userInfo?.images &&
                     this.state.userInfo?.images.map((item) => (
                    <div>
                    <div className="media_image">
                      <img
                        src={
                          item.inSite ? this.apiserve.imageUrl + item.inSite : 
                          item.link ? item.link : 
                         '/images/image-placeholder.png'
                        }
                        alt="image"
                      />
                    </div>
                  </div>
                ))}
                    </Slider>
                    </div>
                    <div className="credit_section mt_15">
                        <div className="credit_header">
                            <h5>Credits</h5>
                        </div>
                        <div className="credit_content">
                            <ul>
                                {/* <li className="d_flex">
                                    <label>Music Supervisor</label>
                                    <span className="name">
                                        <p>dsfj dsf </p>
                                    </span>
                                </li> 
                                <li className="d_flex">   
                                    <label>Music Supervisor</label>
                                    <span className="name">
                                        <p> sdfds ds df</p>
                                        <p> fgdf gh hj kj</p>
                                    </span>
                                </li>
                                <li className="d_flex">    
                                    <label>Casting</label>
                                    <span className="name">
                                        <p> ghjgh hj</p>
                                    </span>
                                </li> */}
                                { <li className="d_flex">
                                    {this.state.userInfo?.credits &&
                                    this.state.userInfo?.credits.map((item) => (
                                    <>
                                    <div className='d_flex' >
                                        <label>{item && item.creditId && item.creditLabel}</label>
                                        <span className="name">
                                        {item.creditType &&
                                        item.creditType.map((creditTypeName) => (
                                            <p>{creditTypeName.firstName} {creditTypeName.middleName} {creditTypeName.lastName}</p>
                                        ))}
                                        </span>
                                        </div>
                                    </>
                                    ))}
                                    
                                </li> }
                            </ul>
                        </div>
                    </div>
                    <div className="credit_section mt_15">
                        <div className="credit_header">
                            <h5>Digital Media</h5>
                        </div>
                        <div className="credit_content no_bg">
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label>Official Website</label>
                                        <span>{this.state.userInfo?.digitalMedia?.officialWebsite}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>YouTube or Vimeo Trailer</label>
                                        <span>{this.state.userInfo?.digitalMedia.youtubeOrVimeoTrailer}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Instagram</label>
                                        <span>{this.state.userInfo?.digitalMedia.instagram}</span>
                                    </li> 
                                    <li className="d_flex">
                                        <label>Facebook</label>
                                        <span>{this.state.userInfo?.digitalMedia.facebook}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Tiktok</label>
                                        <span>{this.state.userInfo?.digitalMedia.tiktok}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>X (Formerly "Twitter")</label>
                                        <span>{this.state.userInfo?.digitalMedia.twitter}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Bluesky</label>
                                        <span>{this.state.userInfo?.digitalMedia.bluesky}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Hashtag</label>
                                        <span>{this.state.userInfo?.digitalMedia.hastag}</span>
                                    </li>
                                    {/* <li className="disp_flex">
                                        <label></label>
                                        <div class="video_wrap"><iframe src={this.state.userInfo?.digitalMedia.yt}></iframe></div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>    
                    <div className="credit_section artist_section">
                        <div className="credit_header">
                            <h5>Meet The Artist</h5>
                        </div>
                        {/* <div className="artist_content">
                            <div className="d_flex inner_artist mb_15">
                                <div className="artist_user"><img src="/images/user.png" alt="user" /></div>
                                <div className="artist_data">
                                <div className="d_flex user_name">
                                    <h4>dfg  fdgfd f</h4>
                                    <div className="d_flex d_flex_align_center"></div>
                                </div>
                                <div className="user_desc">
                                    <div className="editor_view p_0">
                                        <p>sdf gf hfgh h fh gh gh sdf gf hfgh h fh gh ghsdf gf hfgh h fh gh ghsdf gf hfgh h fh gh ghsdf gf hfgh h fh gh ghsdf gf hfgh h fh gh ghsdf gf hfgh h fh gh ghsdf gf hfgh h fh gh ghsdf gf hfgh h fh gh gh</p>
                                    </div>
                                </div>
                                <div class="video_wrap"><iframe src="https://www.youtube.com/embed/uwl1qSKPGac"></iframe></div>
                                </div>
                            </div>
                        </div> */}
                         <div className="artist_content">
                            {
                                this.state.userInfo?.credits && this.state.userInfo?.credits.map((item,i)=>{
                                    return(
                                        <>
                                        {item.identifier=== (this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? 'leadartist' : this.state.userInfo.credits[0].identifier) &&
                                            <>
                                            {item.creditType && item.creditType.map((cred,index)=>{
                                                return(
                                                    <>
                                                    <div className="d_flex inner_artist mb_15">
                                                        <div className="artist_user">
                                                        <img src={cred.creditDetails?.ProfileUrl ? this.apiserve.imageUrl + cred.creditDetails?.ProfileUrl : '/images/user.png'} alt="image" />
                                                            {/* <img src="/images/user.png" alt="user" /> */}
                                                            </div>
                                                        <div className="artist_data">
                                                        <div className="d_flex user_name">
                                                            <h4>{cred.firstName} {cred.middleName} {cred.lastName}</h4>
                                                            <div className="d_flex d_flex_align_center"></div>
                                                        </div>
                                                        <div className="user_desc">
                                                            <div className="editor_view p_0">
                                                                <p>{cred.creditDetails?.bio}</p>
                                                            </div>
                                                        </div>
                                                        {/* <div class="video_wrap"><iframe src="https://www.youtube.com/embed/uwl1qSKPGac"></iframe></div> */}
                                                        <div className="video_wrap">
                                                            <iframe src={getEmbedUrl(cred.creditDetails.youtube)}></iframe>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </>
                                                )
                                            })}
                                            </>
                                        }
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="tab_col feature_col create_feature_col">
                    <h2 className="paf_screening_info_title">Screening/Project Info</h2>
                    <div className="fpg_edits_links mt_0 d_flex d_flex_align_center">
                        <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.editProjectInfo()} >
                            <FpgeeditIcon /> EDIT
                        </Link>
                        {/* <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={this.editTalkAndEvent} >
                            <FpgDisableIcon /> DISABLE
                        </Link> */}
                        
                        {/* <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishFilm()} >
                            <FpgpublishIcon /> PUBLISH
                        </Link> */}
                            {this.state.userInfo?.status === 1?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.disableFilm()}>
                            <FpgDisableIcon /> DISABLE
                            </Link>
                            :              
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.publishFilm()}>
                                <FpgpublishIcon /> PUBLISH
                            </Link>
                            }
                        <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()} >
                            <FpgDeleteIcon />
                            DELETE
                        </Link>
                    </div>
                    {console.log(this.state.userInfo,"this.state.userInfo")}
                    <div className="d_flex border_btm_1">
                        <div className="data_list">
                            <ul className="mb_10">
                                <li className="d_flex">
                                    <label>PAF Type</label>
                                    <span>{this.state.userInfo?.pafType}</span>
                                </li>
                                {isNewFrontierCategory(this.state.userInfo?.category, this.state.filmCategoryData) && (
                                <li className="d_flex">
                                    <label>Film/Project</label>
                                    <span>{this.state.userInfo?.filmProjectType}</span>
                                </li>
                                )}
                                <li className="d_flex">
                                    <label>Category</label>
                                    <span>{this.getCategoryName(this.state.userInfo?.category)}</span>
                                </li> 
                                <li className="d_flex">
                                    <label>Article</label>
                                    <span>{this.state.userInfo?.article}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Title</label>
                                    <span>{this.state.userInfo?.title}</span>
                                </li>
                                <li className="d_flex">
                                    <label>English Phonentic Pronunciation</label>
                                    <span>{this.state.userInfo?.englishPhoneticProdununciation} </span>
                                </li>
                                
                            </ul>
                        </div>
                        <div className="data_list large_que">
                            <ul className="mb_15">
                                <li className="disp_flex">
                                    <label>I understand and agree that if the Closed Caption file is faulty in any way, Sundance Institute may elect to use the Open Caption version for all in- person public screenings.</label>
                                    <span>{this.state.userInfo?.projectInfo.requiredDCPAndProResFile}</span>
                                </li>
                                <li className="disp_flex">
                                    <label>I understand that an Open Caption version of our DCP is required. Open Captions show spoken English and audio description text on screen with the movie for Deaf and hard of hearing viewers at in-person screenings. Non-English language projects are required to provide an SDH ("Subtitles for the deaf and hard of hearing") version to be used for Open Caption screenings.</label>
                                    <span>{this.state.userInfo?.projectInfo.requiredDCP}</span>
                                </li>
                                <li className="disp_flex">
                                    <label>Will your DCP or ProRes include an Audio Description  soundtrack for Blind and low vision viewers?</label>
                                    <span>{this.state.userInfo?.projectInfo.captionAudioInDCP}</span>
                                </li>
                                {/* <li className="disp_flex">
                                    <label>Would you like your Premiere screening to be an Open Caption screening?</label>
                                    <span>{this.state.userInfo?.projectInfo.premiereScreening}</span>
                                </li> */}
                                {/* <li className="disp_flex">
                                    <label>Would you like one of your Repeat screenings to be Open Caption?</label>
                                    <span>{this.state.userInfo?.projectInfo.repeatScreening}</span>
                                </li> */}
                                {/* <li className="disp_flex">
                                    <label>Would you like ALL of your screenings to be Open Caption?</label>
                                    <span>{this.state.userInfo?.projectInfo.allOfYourScreening}</span>
                                </li> */}
                                <li className="disp_flex">
                                    <label>Does your project include stroboscopic images or extensive light flickering that lasts longer than 5 seconds?</label>
                                    <span>{this.state.userInfo?.projectInfo.includeStroboscopicImg} </span>
                                </li>
                                <li className="disp_flex">
                                    <label>Did you use AI in any aspect of your project?</label>
                                    <span>{this.state.userInfo?.projectInfo.aiAspect} </span>
                                </li>
                            </ul>
                        </div>
                        <div class="field_row mb_25">
                            <label class="font_600">logline</label>
                            <div class="editor_view">
                                <p>{this.state.userInfo?.logline}</p>
                            </div>
                        </div> 
                        <div className="data_list">
                            <ul className="mb_15">
                                <li className="d_flex">
                                    <label>Year Finished</label>
                                    <span>{this.state.userInfo?.projectInfo.yearFinished}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Country of Origin</label>
                                    {this.state.userInfo?.countryOfOrigin.map((item)=>{
                                        return(
                                            <span>{item.country}</span>
                                        )
                                    })}
                                </li>
                                <li className="d_flex">
                                    <label>Run Time mins (180 mins max)</label>
                                    <span>{this.state.userInfo?.projectInfo.runTime}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Final Run Time</label>
                                    <span>{this.state.userInfo?.projectInfo.finalRunTime}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Primary Language</label>
                                    <span>{this.state.userInfo?.projectInfo.language}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Subtitles for Non-English language?</label>
                                    <span>{this.state.userInfo?.projectInfo.subtitles}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Premiere Status</label>
                                    <span>{this.state.userInfo?.projectInfo.premiereStatus}</span>
                                </li>
                                {/* <li className="d_flex">
                                    <label>In Person Format</label>
                                    <span>{this.state.userInfo?.projectInfo.inPersonFormat}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Online Format</label>
                                    <span>{this.state.userInfo?.projectInfo.onlineFormat}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Aspect Ratio</label>
                                    <span>{this.state.userInfo?.projectInfo.aspectRatio}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Sound Format</label>
                                    <span>{this.state.userInfo?.projectInfo.soundFormat}</span>
                                </li> */}
                                <li className="d_flex">
                                    <label>Color</label>
                                    <span>{this.state.userInfo?.projectInfo.color}</span>
                                </li>
                            </ul>
                        </div>   
                    </div>
                    <div className="paf_screening_info mt_25 w_100 border_btm_1 pb_25">
                        <h2 className="paf_screening_info_title mb_10">Film Team - Public Contact Information</h2>
                        <div className="mb_10">
                            <p className="paf_screening_info_subtitle uppercase mb_15">PUBLIC CONTACT (DURING FESTIVAL)</p>
                            <div className="data_list">
                                <ul className="mb_5">
                                    <li className="d_flex">
                                        <label>First Name</label>
                                        <span>{this.state.userInfo?.publicContact.firstName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Middle Name</label>
                                        <span>{this.state.userInfo?.publicContact.middleName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Last Name</label>
                                        <span>{this.state.userInfo?.publicContact.lastName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Company</label>
                                        <span>{this.state.userInfo?.publicContact.company}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Public Email</label>
                                        <span>{this.state.userInfo?.publicContact.publicEmail}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Website</label>
                                        <span>{this.state.userInfo?.publicContact.website}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Phone</label>
                                        <span>{this.state.userInfo?.publicContact.phoneNumber}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Phone Type</label>
                                        <span>{this.state.userInfo?.publicContact.type}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="mb_10">
                            <p className="paf_screening_info_subtitle uppercase mb_15">POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                            <div className="data_list">
                                <ul className="mb_5">
                                    <li className="d_flex">
                                        <label>First Name</label>
                                        <span>{this.state.userInfo?.postFestivalContact.firstName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Middle Name</label>
                                        <span>{this.state.userInfo?.postFestivalContact.middleName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Last Name</label>
                                        <span>{this.state.userInfo?.postFestivalContact.lastName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Company</label>
                                        <span>{this.state.userInfo?.postFestivalContact.company}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Public Email</label>
                                        <span>{this.state.userInfo?.postFestivalContact.publicEmail}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Website</label>
                                        <span>{this.state.userInfo?.postFestivalContact.website}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Phone</label>
                                        <span>{this.state.userInfo?.postFestivalContact.phoneNumber}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Phone Type</label>
                                        <span>{this.state.userInfo?.postFestivalContact.type}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="mb_10">
                            <p className="paf_screening_info_subtitle uppercase mb_15">SECOND POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                            <div className="data_list">
                                <ul className="mb_5">
                                    <li className="d_flex">
                                        <label>First Name</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.firstName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Middle Name</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.middleName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Last Name</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.lastName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Company</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.company}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Public Email</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.publicEmail}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Website</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.website}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Phone</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.phoneNumber}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Phone Type</label>
                                        <span>{this.state.userInfo?.secondPostFestivalContact.type}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {this.state.errorPopup ? 
                  <ErrorPopUp
                  errorMsg={this.state.errorMsg}
                  errorMsgPopup={this.errorMsgPopup}
                  />    
              : ''
        }
      {this.state.deleteFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Delete?'
            insideDetails = 'You are about to delete an item and this action is permanent'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.deleteFilmPopupYes}
          />
        :''}

      {this.state.publishFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Publish Changes'
            insideDetails = 'Saving the current changes will publish it to the production site'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.publishFilmPopupYes}
          />
        :''}

      {this.state.disableFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Disable?'
            insideDetails = 'You are about to disable an item, which will temporarily make it unavailable on the production site'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.disableFilmPopupYes}
          />
        :''}
         {this.state.loaderFlag ? (
                    <Loader />
          ) : (
                  ""
            )}
        </>   
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectinfoView)
// export default ProjectinfoView